// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shared search appearance matches the quotation register. The marker covers
   shared controls; type/placeholder selectors cover existing native searches.
   Important colours also override legacy header and MUI theme declarations. */
body input:is([data-search-input="true"], [type="search"], [placeholder*="search" i]):not(:disabled)::placeholder {
  color: var(--text-secondary, #506360) !important;
  opacity: 1 !important;
}

/* Only the immediate input wrapper is styled, so cards and menus are unaffected.
   Keep focused, invalid, disabled and read-only controls in their existing states. */
body :is(label, [class*="search" i], .quotation-input-box, .MuiInputBase-root):has(> input:is([data-search-input="true"], [type="search"], [placeholder*="search" i]):enabled:not([readonly]):not([aria-invalid="true"])):hover:not(:focus-within):not(.Mui-error):not(.error),
body input:is([data-search-input="true"], [type="search"], [placeholder*="search" i]):enabled:not([readonly]):not([aria-invalid="true"]):hover:not(:focus) {
  border-color: var(--border-strong, #8b9996) !important;
}

/* MUI outlined fields draw their border on a sibling fieldset. */
body .MuiOutlinedInput-root:has(> input:is([data-search-input="true"], [type="search"], [placeholder*="search" i]):enabled:not([readonly])):hover:not(:focus-within):not(.Mui-focused):not(.Mui-error) > .MuiOutlinedInput-notchedOutline {
  border-color: var(--border-strong, #8b9996) !important;
}

/* Figma Search / Focus (140:7095): the field has one owner. Search controls
   composed from an icon, input and clear action draw the 2px focus border and
   3px cyan ring on their immediate wrapper; the nested input never draws a
   second outline. The class fragment is intentionally limited by the direct
   input relationship, so search result panels and page containers are ignored. */
body
  :is(label, [class*="search" i], .quotation-input-box)
  > input:is(
    [data-search-input="true"],
    [type="search"],
    [placeholder*="search" i]
  ):not(.MuiInputBase-input) {
  min-height: 0 !important;
  height: 100%;
  padding: 0 !important;
  background: transparent !important;
  border: 0 !important;
  border-radius: 0 !important;
  outline: 0 !important;
  box-shadow: none !important;
}

body
  :is(label, [class*="search" i], .quotation-input-box)
  > input:is(
    [data-search-input="true"],
    [type="search"],
    [placeholder*="search" i]
  ):not(.MuiInputBase-input):focus,
body
  :is(label, [class*="search" i], .quotation-input-box)
  > input:is(
    [data-search-input="true"],
    [type="search"],
    [placeholder*="search" i]
  ):not(.MuiInputBase-input):focus-visible {
  border: 0 !important;
  outline: 0 !important;
  box-shadow: none !important;
}

body
  :is(label, [class*="search" i], .quotation-input-box)
  :has(
    > input:is(
      [data-search-input="true"],
      [type="search"],
      [placeholder*="search" i]
    ):enabled:not([readonly]):not([aria-invalid="true"]):focus
  ):not(.Mui-error):not(.error) {
  box-sizing: border-box;
  border: 2px solid var(--interactive-default, #0f766e) !important;
  outline: 0 !important;
  box-shadow: var(
    --field-focus-ring,
    0 0 0 3px rgba(15, 186, 196, 0.22)
  ) !important;
}

/* Standalone native searches use the same state directly on the input. */
body
  input:is(
    [data-search-input="true"],
    [type="search"],
    [placeholder*="search" i]
  ):not(.MuiInputBase-input):not(:is(label, [class*="search" i], .quotation-input-box) > input):enabled:not([readonly]):not([aria-invalid="true"]):focus {
  border: 2px solid var(--interactive-default, #0f766e) !important;
  outline: 0 !important;
  box-shadow: var(
    --field-focus-ring,
    0 0 0 3px rgba(15, 186, 196, 0.22)
  ) !important;
}

/* MUI search fields keep their notched outline but share the exact Figma ring. */
body
  .MuiOutlinedInput-root.Mui-focused:has(
    input:is(
      [data-search-input="true"],
      [type="search"],
      [placeholder*="search" i]
    ):not([aria-invalid="true"])
  ):not(.Mui-error) {
  outline: 0 !important;
  box-shadow: var(
    --field-focus-ring,
    0 0 0 3px rgba(15, 186, 196, 0.22)
  ) !important;
}

body
  .MuiOutlinedInput-root.Mui-focused:has(
    input:is(
      [data-search-input="true"],
      [type="search"],
      [placeholder*="search" i]
    ):not([aria-invalid="true"])
  ):not(.Mui-error)
  > .MuiOutlinedInput-notchedOutline {
  border-color: var(--interactive-default, #0f766e) !important;
  border-width: 2px !important;
}
`, "",{"version":3,"sources":["webpack://./src/styles/search-inputs.css"],"names":[],"mappings":"AAAA;;8EAE8E;AAC9E;EACE,gDAAgD;EAChD,qBAAqB;AACvB;;AAEA;qFACqF;AACrF;;EAEE,sDAAsD;AACxD;;AAEA,iEAAiE;AACjE;EACE,sDAAsD;AACxD;;AAEA;;;;iFAIiF;AACjF;;;;;;;EAOE,wBAAwB;EACxB,YAAY;EACZ,qBAAqB;EACrB,kCAAkC;EAClC,oBAAoB;EACpB,2BAA2B;EAC3B,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;;;;;;;;;;;;;;EAcE,oBAAoB;EACpB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;;;;;;;;;EASE,sBAAsB;EACtB,gEAAgE;EAChE,qBAAqB;EACrB;;;cAGY;AACd;;AAEA,yEAAyE;AACzE;;;;;;EAME,gEAAgE;EAChE,qBAAqB;EACrB;;;cAGY;AACd;;AAEA,iFAAiF;AACjF;;;;;;;;EAQE,qBAAqB;EACrB;;;cAGY;AACd;;AAEA;;;;;;;;;EASE,4DAA4D;EAC5D,4BAA4B;AAC9B","sourcesContent":["/* Shared search appearance matches the quotation register. The marker covers\n   shared controls; type/placeholder selectors cover existing native searches.\n   Important colours also override legacy header and MUI theme declarations. */\nbody input:is([data-search-input=\"true\"], [type=\"search\"], [placeholder*=\"search\" i]):not(:disabled)::placeholder {\n  color: var(--text-secondary, #506360) !important;\n  opacity: 1 !important;\n}\n\n/* Only the immediate input wrapper is styled, so cards and menus are unaffected.\n   Keep focused, invalid, disabled and read-only controls in their existing states. */\nbody :is(label, [class*=\"search\" i], .quotation-input-box, .MuiInputBase-root):has(> input:is([data-search-input=\"true\"], [type=\"search\"], [placeholder*=\"search\" i]):enabled:not([readonly]):not([aria-invalid=\"true\"])):hover:not(:focus-within):not(.Mui-error):not(.error),\nbody input:is([data-search-input=\"true\"], [type=\"search\"], [placeholder*=\"search\" i]):enabled:not([readonly]):not([aria-invalid=\"true\"]):hover:not(:focus) {\n  border-color: var(--border-strong, #8b9996) !important;\n}\n\n/* MUI outlined fields draw their border on a sibling fieldset. */\nbody .MuiOutlinedInput-root:has(> input:is([data-search-input=\"true\"], [type=\"search\"], [placeholder*=\"search\" i]):enabled:not([readonly])):hover:not(:focus-within):not(.Mui-focused):not(.Mui-error) > .MuiOutlinedInput-notchedOutline {\n  border-color: var(--border-strong, #8b9996) !important;\n}\n\n/* Figma Search / Focus (140:7095): the field has one owner. Search controls\n   composed from an icon, input and clear action draw the 2px focus border and\n   3px cyan ring on their immediate wrapper; the nested input never draws a\n   second outline. The class fragment is intentionally limited by the direct\n   input relationship, so search result panels and page containers are ignored. */\nbody\n  :is(label, [class*=\"search\" i], .quotation-input-box)\n  > input:is(\n    [data-search-input=\"true\"],\n    [type=\"search\"],\n    [placeholder*=\"search\" i]\n  ):not(.MuiInputBase-input) {\n  min-height: 0 !important;\n  height: 100%;\n  padding: 0 !important;\n  background: transparent !important;\n  border: 0 !important;\n  border-radius: 0 !important;\n  outline: 0 !important;\n  box-shadow: none !important;\n}\n\nbody\n  :is(label, [class*=\"search\" i], .quotation-input-box)\n  > input:is(\n    [data-search-input=\"true\"],\n    [type=\"search\"],\n    [placeholder*=\"search\" i]\n  ):not(.MuiInputBase-input):focus,\nbody\n  :is(label, [class*=\"search\" i], .quotation-input-box)\n  > input:is(\n    [data-search-input=\"true\"],\n    [type=\"search\"],\n    [placeholder*=\"search\" i]\n  ):not(.MuiInputBase-input):focus-visible {\n  border: 0 !important;\n  outline: 0 !important;\n  box-shadow: none !important;\n}\n\nbody\n  :is(label, [class*=\"search\" i], .quotation-input-box)\n  :has(\n    > input:is(\n      [data-search-input=\"true\"],\n      [type=\"search\"],\n      [placeholder*=\"search\" i]\n    ):enabled:not([readonly]):not([aria-invalid=\"true\"]):focus\n  ):not(.Mui-error):not(.error) {\n  box-sizing: border-box;\n  border: 2px solid var(--interactive-default, #0f766e) !important;\n  outline: 0 !important;\n  box-shadow: var(\n    --field-focus-ring,\n    0 0 0 3px rgba(15, 186, 196, 0.22)\n  ) !important;\n}\n\n/* Standalone native searches use the same state directly on the input. */\nbody\n  input:is(\n    [data-search-input=\"true\"],\n    [type=\"search\"],\n    [placeholder*=\"search\" i]\n  ):not(.MuiInputBase-input):not(:is(label, [class*=\"search\" i], .quotation-input-box) > input):enabled:not([readonly]):not([aria-invalid=\"true\"]):focus {\n  border: 2px solid var(--interactive-default, #0f766e) !important;\n  outline: 0 !important;\n  box-shadow: var(\n    --field-focus-ring,\n    0 0 0 3px rgba(15, 186, 196, 0.22)\n  ) !important;\n}\n\n/* MUI search fields keep their notched outline but share the exact Figma ring. */\nbody\n  .MuiOutlinedInput-root.Mui-focused:has(\n    input:is(\n      [data-search-input=\"true\"],\n      [type=\"search\"],\n      [placeholder*=\"search\" i]\n    ):not([aria-invalid=\"true\"])\n  ):not(.Mui-error) {\n  outline: 0 !important;\n  box-shadow: var(\n    --field-focus-ring,\n    0 0 0 3px rgba(15, 186, 196, 0.22)\n  ) !important;\n}\n\nbody\n  .MuiOutlinedInput-root.Mui-focused:has(\n    input:is(\n      [data-search-input=\"true\"],\n      [type=\"search\"],\n      [placeholder*=\"search\" i]\n    ):not([aria-invalid=\"true\"])\n  ):not(.Mui-error)\n  > .MuiOutlinedInput-notchedOutline {\n  border-color: var(--interactive-default, #0f766e) !important;\n  border-width: 2px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
